<script setup lang="ts">
import { computed, watch } from 'vue'
import { useTranslate } from '@tolgee/vue'

import { type TopStat, IMPACT_TYPES } from '@/api/interfaces'
import { useEditorStore } from '@/stores/Editor'

import ErrorMessage from '@/components/common/ErrorMessage.vue'

const editorStore = useEditorStore()
const { t } = useTranslate('local')
const impactTypes: TopStat[] = [...IMPACT_TYPES, 'monthsEarthPositive']

const hasSelectedImpact = computed(() => {
  return Object.entries(editorStore.editor.icon.impactDisplay)
    .filter(([key]) => key !== 'hideZeroValues')
    .some(([, value]) => value)
})

watch(
  () => editorStore.editor.icon.impactDisplay,
  () => {
    editorStore.valid = hasSelectedImpact.value
  },
  { deep: true },
)
</script>

<template>
  <div class="editor-settings-impact-display">
    <v-checkbox
      v-for="impactType in impactTypes"
      v-model="editorStore.editor.icon.impactDisplay[impactType]"
      :key="impactType"
      :label="t(`EditorImpactSettings.displayed.${impactType}`)"
      :disabled="editorStore.editor.icon.impactDisplay.hideZeroValues"
    />
    <v-checkbox
      v-model="editorStore.editor.icon.impactDisplay.hideZeroValues"
      :label="t('EditorImpactSettings.displayed.hideZeroValues')"
      class="editor-settings-impact-display-zero"
    />
    <ErrorMessage
      v-if="!hasSelectedImpact"
      :message="t('EditorImpactSettings.displayed.errorMessage')"
    />
  </div>
</template>

<style lang="scss" scoped>
.editor-settings-impact-display {
  .v-checkbox {
    --v-input-control-height: 40px;
  }
}

.editor-settings-impact-display-zero {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--gray-light-cc);
}
</style>
